module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d5f612fcbc4be45012074bc10ccd52d1.png";